<template>
  <div class="c-tabs-content">
    <Spin size="large" fix v-if="loading" />
    <div class="c-search">
      <Input v-model="keyword" placeholder="请输入关键字搜索" clearable search />
    </div>
    <div class="c-table">
      <el-table ref="table" class="common-el-table-styles" stripe border :height="500" :data="packages" @sort-change="sortChange">
        <el-table-column
          v-for="(col, id) in columns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :min-width="col.width"
          :sortable="col.sortable"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :formatter="col.format"
          :sort-orders="['descending', 'ascending', null]"
        >
          <template slot-scope="scope">
            <el-button type="text" v-if="col.key === 'control'" :disabled="disabled" @click="$emit('on-add', scope.row)">添加</el-button>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { isEmpty, trim } from '@/common/js/utils'

const columns = [
  {
    title: '意图词',
    key: 'wtpName'
  },
  {
    title: '意图词举例',
    key: 'shortKeyWords',
    overflow: true
  },
  {
    title: '流量覆盖',
    key: 'hotLevel',
    width: '82',
    sortable: 'custom'
  },
  {
    title: '操作',
    key: 'control'
  }
]

export default {
  name: '',
  props: {
    loading: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    data: {
      type: Array
    }
  },
  computed: {
    packages() {
      const keyword = trim(this.keyword).toLowerCase()
      return this.data.filter((ret) => isEmpty(keyword) || ret.wtpName.toLowerCase().includes(keyword))
    }
  },
  data() {
    return {
      keyword: '',
      columns: columns
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    doLayout() {
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tabs-content {
  .c-search {
    padding: 6px 0;
  }
}
</style>
